/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_DescriptionInputs */

const en_admin_tickets_description = /** @type {(inputs: Admin_Tickets_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View and reply to user tickets`)
};

const zh_admin_tickets_description = /** @type {(inputs: Admin_Tickets_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看并回复用户提交的工单`)
};

/**
* | output |
* | --- |
* | "View and reply to user tickets" |
*
* @param {Admin_Tickets_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_description = /** @type {((inputs?: Admin_Tickets_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_description(inputs)
	return zh_admin_tickets_description(inputs)
});
export { admin_tickets_description as "admin.tickets.description" }